import React, { useState } from 'react';
import Button from '@components/atoms/button/button';
import { useTranslation } from 'next-i18next';
import clsx from 'clsx';
import Spinner from '@components/atoms/spinner/spinner';
import styles from './success-popin.module.scss';

type SuccessPopinProps = {
  redirectLink: string;
  modalDialogTitleId?: string;
};

const SuccessPopin: React.FC<SuccessPopinProps> = ({ redirectLink, modalDialogTitleId }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState<boolean>(false);

  const handleLinkClick = (redirectLink: string) => {
    setLoading(true);
    window.location.href = redirectLink;
  };

  return (
    <div className={styles.success__popin}>
      <h2
        id={modalDialogTitleId}
        className="visuallyhidden"
      >
        {t('DROP_THE_PRICE.SUCCESS_MSG', 'price-drop')}
      </h2>
      <div className={clsx(styles.success__popin__text, 'vc-text-m')}>{t('DROP_THE_PRICE.SUCCESS_MSG')}</div>
      <div className={clsx('vc-text-m')}>
        <Button
          className="vc-btn vc-btn--primary vc-btn--small"
          onClick={() => handleLinkClick(redirectLink)}
          disabled={loading}
        >
          {t('MODAL.BUTTON.CLOSE')}
          {loading && <Spinner className={styles.success__popin__redirect} />}
        </Button>
      </div>
    </div>
  );
};

export default SuccessPopin;
